// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tools-box[data-v-687cea86] {\n  display: flex;\n  align-items: center;\n}\n.tools-box .tips-item[data-v-687cea86] {\n  margin-left: 15px;\n  font-size: 16px;\n}\n.down-link[data-v-687cea86] {\n  margin-right: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
